import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

import { Text } from './text';

interface MetricStatProps {
  icon: ReactNode;
  label: string;
  value: string;
}

export const MetricStat = ({
  icon,
  label,
  value,
}: MetricStatProps): JSX.Element => {
  return (
    <Box
      title={label}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'action.hover',
        borderRadius: 999,
        py: 0.5,
        pl: 0.5,
        pr: 1.5,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 28,
          height: 28,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          opacity: 0.9,
        }}
      >
        {icon}
      </Box>
      <Text
        variant="caption"
        tone="muted"
        sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
      >
        {label}
      </Text>
      <Text variant="label" sx={{ whiteSpace: 'nowrap' }}>
        {value}
      </Text>
    </Box>
  );
};
